import { useQuery, useMutation } from '@tanstack/react-query';

import AccountUserApi from '../../../../../lib/api/account/user/AccountUserApi';
import { setRequestForm } from '../../../../../lib/common';
import { accountUserDetailKey } from '../common/queryKeys';

export const useAccountUserCsQnaDetailQuery = ({ userId, pagination, sortOption, filterOption, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'csQna', 'detail', userId, pagination, sortOption, filterOption],
    async () => {
      const result = await AccountUserApi.getAccountUserCsQnaDetail(
        setRequestForm({ userId, csQnaHistory: { pagination, sortOption, filterOption } }, true),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: { data: { csQnaList: { list: [], totalCnt: 0 } } },
    },
  );
};

export const useAccountUserDetailCsQnaListExcelDownloadMutate = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const result = await AccountUserApi.getAccountUserDetailCsQnaListExcelDownload(setRequestForm(payload, true));
      if (result.msg) throw new Error(result.msg);
      return result;
    },
  });
};
